/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheClasseMiseAJourMasseGridDto } from './FcbRechercheClasseMiseAJourMasseGridDto';
import {
    FcbRechercheClasseMiseAJourMasseGridDtoFromJSON,
    FcbRechercheClasseMiseAJourMasseGridDtoFromJSONTyped,
    FcbRechercheClasseMiseAJourMasseGridDtoToJSON,
} from './FcbRechercheClasseMiseAJourMasseGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResults
 */
export interface FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheClasseMiseAJourMasseGridDto>}
     * @memberof FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResults
     */
    results?: Array<FcbRechercheClasseMiseAJourMasseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheClasseMiseAJourMasseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResultsFromJSON(json: any): FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResults {
    return FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheClasseMiseAJourMasseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResultsToJSON(value?: FcbRechercheClasseMiseAJourMasseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheClasseMiseAJourMasseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

